// extracted by mini-css-extract-plugin
module.exports = {"sliderLayout":"DRq7"};